<template>
  <div class="address-suggest-input city-input-component">
    <vue-suggest
      :destyled="true"
      v-model="model"
      :list="getList"
      :max-suggestions="30"
      :min-length="3"
      :debounce="400"
      :controls="controls"
      mode="select"
      :nullable-select="false"
      ref="suggestComponent"
      value-attribute="name"
      display-attribute="name"
      @select="handleSuggestSelect"
      @input="onInput"
    >
      <template slot="misc-item-above" slot-scope="{ suggestions, query }">
        <div
          class="misc-item items-found"
          v-if="suggestions.length > 0 && !loading"
        >
          <span>Выберите один из городов(регионов) в списке</span>
        </div>
        <div class="misc-item" v-else-if="!loading">
          <span>Ничего не найдено по запросу "{{ query }}"</span>
        </div>
      </template>

      <div slot="suggestion-item" slot-scope="scope">
        <div class="suggestion-item__text">
          <div v-html="boldenSuggestion(scope)"></div>
        </div>
      </div>

      <div class="misc-item" slot="misc-item-below" v-if="loading">
        <span>Поиск...</span>
      </div>
    </vue-suggest>
  </div>
</template>

<script>
  import VueSuggest from 'vue-simple-suggest'

  export default {
    name: 'CityInput',
    components: {
      VueSuggest,
    },
    props: {
      placeholder: {
        type: String,
        default: '',
      },
      initVal: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        selected: null,
        model: null,
        loading: false,
        log: [],
        controls: {
          selectionUp: [38, 33],
          selectionDown: [40, 34],
          select: [13, 36],
          showList: [40],
          hideList: [27, 35],
        },
      }
    },
    watch: {
      val (newValue) {
        if (this.selected && this.selected.name !== newValue) {
          this.selected = null
          this.handleSuggestSelect(null)
          this.$emit('input', this.model)
        }
      },
    },
    computed: {
      val () {
        return this.model
      },
    },
    methods: {
      boldenSuggestion (scope) {
        if (!scope) return scope

        const { suggestion, query } = scope

        const result = this.$refs.suggestComponent.displayProperty(suggestion)

        if (!query) return result

        const texts = query.split(/[\s-_/\\|.]/gm).filter((t) => !!t) || ['']
        return result.replace(
          new RegExp('(.*?)(' + texts.join('|') + ')(.*?)', 'gi'),
          '$1<b>$2</b>$3',
        )
      },
      getList (query) {
        this.loading = true
        return this.$store
          .dispatch('suggests/getSuggestCity', { query })
          .finally(() => {
            this.loading = false
          })
      },
      handleSuggestSelect (suggest) {
        this.$emit('selected', suggest)
        this.selected = suggest
      },
      onInput () {
        this.$nextTick(() => {
          this.$emit('input', this.model)
        })
      },
    },
    created () {
      if (this.initVal) {
        this.model = { ...this.initVal }
      }
    },
  }
</script>

<style lang="less">
  .city-input-component {
    position: relative;

    .input-text_input,
    .default-input {
      height: 80px;
      background-color: @color-secondary !important;
      border-radius: 15px;
      font-size: 25px;
      line-height: 18px;
      outline: none;
    }

    .text-field {
      &.v-input--is-focused {
        .v-input__slot {
          border: 2px solid #ff9500;
        }
      }

      .v-input__slot {
        height: 80px;
        background-color: @color-secondary !important;
        border-radius: 15px;

        input {
          font-size: 25px;
          line-height: 18px;
          outline: none;
        }
      }
    }

    b {
      font-weight: bold;
    }

    .vue-simple-suggest {
      .input-wrapper input {
        border: 2px solid transparent;
        transition: all 0.1s ease;
      }
      &.focus .input-wrapper input {
        border: 2px solid #ff9500;
      }
      /*.input-wrapper[aria-expanded="true"] input {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }*/

      .suggestions {
        position: absolute;
        left: 0;
        right: 0;
        top: 100%;
        //top: calc(100% + 5px);
        //border: 1px solid #e1e1e1;
        //border: 1px solid #ff9500;
        //border-top: none;
        background-color: #fff;
        opacity: 1;
        z-index: 1000;
        max-height: 340px;
        overflow-y: auto;
        //box-shadow: 0 3px 14px rgb(128 128 128 / 16%);
        border-radius: 15px;
        font-size: 16px;
        list-style: none;
        margin: 0;
        padding: 0;
        /*box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2),
          0px 8px 10px 1px rgba(0, 0, 0, 0.14),
          0px 3px 14px 2px rgba(0, 0, 0, 0.12);*/
        box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.2);

        .misc-item {
          span {
            margin-bottom: 0;
          }

          &.items-found {
            color: #fe7e00;
            //font-weight: 500;
          }
        }
      }

      .suggestions .suggest-item {
        cursor: pointer;
        user-select: none;
        font-size: 16px;
        padding-top: 10px;
        padding-bottom: 10px;
        border-top: 1px solid #f2f2f2;

        .area {
          font-weight: bold;
          font-size: 16px;
          margin-bottom: 4px;
        }
      }

      .suggestions .suggest-item,
      .suggestions .misc-item {
        padding: 10px 10px;
      }

      .suggestions .suggest-item.hover {
        background-color: #f2f2f2 !important;
        // color: #fff !important;
      }
    }
  }
</style>
